<template>
        <div class="ur-progress__wrapper" :class="wrapperClass">
            <!-- [TYPE] Circle -->
            <svg v-if="isCircle" class="ur-progress__circle" :class="circleClass" :style="circleStyle" viewBox="0 0 480 480" >
                <circle cx="240" cy="240" r="216" fill="none"
                        :class="circleBackgroundClass" stroke-width="48"></circle>
                <circle cx="240" cy="240" r="216" fill="none"
                        :class="circleProgressClass" stroke-width="48"
                        :stroke-dasharray="strokeCircle" :stroke-dashoffset="strokeCircleOffset"></circle>
            </svg>
            <!-- [TYPE] Line -->
            <div v-if="isLine" class="ur-progress__line" :class="lineClass" :style="lineStyle">
                <div class="ur-progress__line-progress"
                     :class="lineProgressClass"
                     :style="lineProgressStyle"></div>
            </div>
            <!-- [TYPE] none -->
            <div v-if="messageDirection !== 'none'" :class="textClass" >{{message}}</div>
        </div>
</template>

<script>
    // ur-indeterminate-progress 는 처리중인 과정이나 데이터를 불확정된 시각적 양으로 표현해주는 컴포넌트 입니다.
    // #ur-indeterminate-progress is a component that expresses the process or data being processed in an indeterminate visual quantity.
export default {
    name :"urIndeterminateProgress",
    props: {

        // $ver: v0.1.0
        // 컴포넌트의 크기를 지정하는 속성입니다. 'small', 'medium', 'large' 세 가지 속성을 지정할 수 있습니다.
        // #This property specifies the size of the component. You can specify three properties: "small", "medium", and "large".
        size: { /* small, medium, large */
            type: String,
            default: 'medium'
        },

        // $ver: v0.1.0
        // 유형입니다. 원형으로 표현되는 'circle'과 막대 형태로 표시되는 'line' 속성을 지정할 수 있습니다.
        // #Type. You can specify 'circle' as a circle and 'line' as a bar.
        shape: { /* circle, line*/
            type: String,
            default: 'circle'
        },

        // $ver: v0.1.0
        // $hide
        // 배경화면 반전 시 시인성을 높이기 위해 컴포넌트 색상을 지정하기 위한 속성입니다. 'normal','light','error' 세 가지 속성을 지정할 수 있습니다.
        // #This property is used to specify the component color for better visibility when the background is reversed. Two properties can be specified: 'normal', 'light', 'error'.
        color : { /* normal, light, error */
            type: String,
            default: 'normal'
        },

        // $ver: v0.1.0
        // 추가 텍스트가 표시될 위치를 지정하는 속성입니다. 'none' 지정 시 텍스트가 표시되지 않으며, 'right','bottom' 속성을 지정할 수 있습니다.
        // #This property specifies where additional text is displayed. If you specify 'none', no text is displayed. You can specify the 'right' and 'bottom' properties.
        messageDirection: { /* none, right, bottom */
            type: String,
            default: 'none'
        },

        // $ver: v0.1.0
        // 진행비율 값 지정 시 반영되는 속도입니다.
        // #The speed that is reflected when specifying the progress rate value.
        speed: {type: Number, default: 0.9},

        // $ver: v0.1.0
        // 우측 또는 하단에 위치할 추가 텍스트 입니다. messageDirection 이 'right' 또는 'bottom'으로 지정돼있지 않으면 표시되지 않습니다.
        // #Additional text to be placed on the right or bottom. If messageDirection is not specified as 'right' or 'bottom', it is not displayed.
        message: {type: String, default: ''},

        // $ver: v0.1.0
        // 현재 사용되지 않는 속성입니다.
        // #This property is not currently used.
        // $deprecated
        // $default: false
        masked: {type: Boolean, default: false,},

        // $ver: v0.1.0
        // 진행 중 오류 발생 시 색상전환을 위한 속성입니다. true로 지정하면 오류발생 색상으로 바뀝니다.
        // #This attribute is for color conversion when an error occurs in progress. If set to true, the color of error will be changed.
        // $default: false
        error: {type: Boolean, default: false},

        // $ver: v0.1.0
        // 막대형 프로그래스인 경우 컴포넌트의 너비값 입니다. 지정하지 않은 경우 기본 단위는 px 입니다.
        // #For bar progress, this is the width of the component. If not specified, default unit is px.
        width: {type: [Number, String], default: "100%"},
    },
    data () {return {
        strokeCircle: 0,
        strokeCircleOffset: 0
    }},
    mounted() {
        this.updateValue (75);
    },
    computed: {
        isLine () { return this.shape === 'line'; },
        isCircle () { return this.shape === 'circle'; },
        wrapperClass() {
            let clazz = [];
            clazz.push('ur-progress-' + this.size);
            clazz.push('ur-progress__wrapper-' + this.messageDirection);
            if(this.masked) clazz.push('ur-progress__wrapper-masked');
            return clazz;
        },
        circleClass() {
            let clazz = [];
            clazz.push('ur-progress__circle-' + this.size);
            clazz.push('ur-progress__circle-spin');
            return clazz;
        },
        circleBackgroundClass() {
            return ['ur-progress__circle-background-' + this.color,];
        },
        circleProgressClass() {
            let clazz = [];
            clazz.push('ur-progress__circle-progress-' + this.color);
            if(this.error) clazz.push('ur-progress__circle-progress-error')
            return clazz;
        },
        circleStyle() {
            let arrStyle={};
            arrStyle['animation'] = 'ur-progress__spin ' + this.speed + 's linear infinite';
            return arrStyle;
        },
        lineClass() {
            return ['ur-progress__line-background-' + this.color];
        },
        lineStyle() {
            let arrStyle={};
            if(isNaN(this.width)) arrStyle['width'] = this.width;
            else arrStyle['width'] = this.width + 'px';
            return arrStyle;
        },
        lineProgressClass() {
            let clazz = [];
            clazz.push('ur-progress__line-progress-' + this.color);
            if(this.error) clazz.push('ur-progress__line-progress-error');
            return clazz
        },
        lineProgressStyle() {
            let arrStyle={};
            arrStyle['width'] = '80px';
            arrStyle['animation'] = 'ur-progress__line-transform ' + this.speed + 's linear infinite'
            return arrStyle;

        },
        //text
        textClass () {
            return [
                'ur-progress__text',
                'ur-progress__text-' + this.messageDirection,
                'ur-progress__text-' + this.color,
                this.error && 'ur-progress__text-error',
            ];
        },
    },
    methods: {
        updateValue (val) {
            if (this.isCircle) {
                this.strokeCircle = 2 * Math.PI * 216;
                this.strokeCircleOffset = this.strokeCircle * ((100 - val) / 100);
            }
        },
    },
}
</script>
